import { AssistantLoadBaseMessage, LoadFinderActionTypes } from '@numeo/types'
import { AppDispatch } from 'store'
import { updateAssistantLoads } from 'store/loadAssistantSlice'

export const handleAssistantLoadMessages = (message: AssistantLoadBaseMessage, dispatch: AppDispatch) => {
    switch (message.data.action) {
        case LoadFinderActionTypes.LF_DirectLoadUpdate:
            dispatch(updateAssistantLoads({ updatedLoads: { [message.data.load._id]: message.data.load } }))
            break
    }
}
